<template>
    <div class="delete-action">
        <button 
            type="button"
            class="btn btn-default btn-sm"
            aria-label="Izbriši"
            @click.prevent="deleteItem">
            <i 
                class="fa fa-times text-red" 
                aria-hidden="true"/>
        </button>
    </div>
</template>
<script>
import VuejsDialog from 'vuejs-dialog';

Vue.use(VuejsDialog);

export default {
    name: 'ContactVersionDelete',

    props  : {
        rowData : {
            type    : Object,
            required: true
        },
        rowIndex: {
            type:    Number,
            default: 0
        }
    },

    methods: {
        deleteItem () {
            this.$dialog.confirm('Ali ste prepričani, da hočete izbrisati vnos?', {
                okText:     'Da',
                cancelText: 'Ne',
            })
                .then(() => {
                    this.$events.fire('deleteContactVersion', this.rowData, true);
                })
                .catch(() => {
                    // Nothing
                });
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Contacts/Actions/ContactVersionDelete.vue